module.exports = __webpack_public_path__ + "img/monaco-logo-icon.5d58e982.png";